module.exports = __webpack_public_path__ + "img/share.1d440d40.png";